import { Box, Typography } from '@mui/material'
import TimeAndDataSourcesFooter from '../shared/TimeAndDataSourcesFooter';

function UserQuery({ query, created_at, sources, isFloatingChat = false }
    : { query: string, created_at: string, sources?: any, isFloatingChat?: boolean }) {
    return (
        <>
            <Box sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
                gap: 1,
                padding: isFloatingChat ? 3 : 4,
                paddingRight: isFloatingChat ? 5 : 8,
                boxSizing: 'border-box',
                background: '#D9D9D940',
                borderRadius: 1,
            }}>
                <Typography variant='body1'
                    sx={{
                        fontStyle: 'italic',
                        textWrap: 'pretty',
                        padding: 0,
                        lineHeight: 1,
                    }}>
                    {query}
                </Typography>
                <TimeAndDataSourcesFooter time={created_at}
                    category={'request'}
                    dataSources={sources}
                    hideDataSources={isFloatingChat} ></TimeAndDataSourcesFooter>
            </Box>
        </>
    )
}

export default UserQuery